import { ADDRESS_TYPES } from '../../models/Address';

class AddressSerializer {
  static deSerializeType(type) {
    switch (type) {
      case 'Domicilio':
        return ADDRESS_TYPES.HOUSE;
      case 'Trabajo':
        return ADDRESS_TYPES.WORK;
      case 'Balneario':
        return ADDRESS_TYPES.HOLIDAY_HOUSE;
      case 'Otro':
        return ADDRESS_TYPES.OTHER;
      default:
        return null;
    }
  }

  static deSerialize(data) {
    const streetData = data.Calle || {};
    const location = streetData.Localidad || {};
    const department = location.Departamento || {};
    const coordinates = data.MapaCliente || data.MapaPunto || {};
    const extraInfo1 = data.Campo1;
    const extraInfo2 = data.Campo2;
    return {
      addressType: AddressSerializer.deSerializeType(data.NombreDireccion.trim()),
      deliveryDisabled: data.EsZonaRoja,
      cityName: {
        id: location.ID,
        name: location.Nombre,
      },
      corner1: ((data.Esquina1 || {}).Nombre || '').trim(),
      corner2: ((data.Esquina2 || {}).Nombre || '').trim(),
      department: {
        id: department.ID,
        name: department.Nombre,
      },
      doorNumber: data.NumeroPuerta ? String(data.NumeroPuerta) : null,
      id: String(data.ID),
      additionalData: data.Ampliacion || '',
      streetName: streetData.Nombre,
      coordinates: {
        latitude: coordinates.Latitud,
        longitude: coordinates.Longitud,
      },
      bis: data.Bis,
      apartment: (data.Apartamento || '').trim(),
      letter: data.Letra,
      extraInfo1: !extraInfo1 ? null : {
        value: extraInfo1.Valor,
        field: {
          id: (extraInfo1.Campo || {}).ID,
          label: (extraInfo1.Campo || {}).Nombre,
        },
      },
      extraInfo2: !extraInfo2 ? null : {
        value: extraInfo2.Valor,
        field: {
          id: (extraInfo2.Campo || {}).ID,
          label: (extraInfo2.Campo || {}).Nombre,
        },
      },
    };
  }

  static deSerializeNewApi(data) {
    return {
      id: data.id,
    };
  }
}

export { AddressSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/AddressSerializer.js